import "./CoursePage.css";
import { useState } from "react";
import heroImg from "./assets/pythondsa.png";

const modulesData = [
  {
    title: "Programming Foundations",
    percent: 0,
    topics: [
      "Logic Building",
      "Flowcharts",
      "Problem Solving",
      "Basic Algorithms",
    ],
  },
  {
    title: "HTML & CSS",
    percent: 0,
    topics: [
      "HTML Structure",
      "Forms",
      "Flexbox & Grid",
      "Responsive Design",
      "Animations",
    ],
  },
  {
    title: "JavaScript Core",
    percent: 65,
    topics: [
      "Variables & Data Types",
      "Functions & Scope",
      "DOM Manipulation",
      "Events",
      "ES6 Concepts",
      "API Fetching",
    ],
    project: "Interactive Website (Ongoing)",
  },
  {
    title: "React Frontend",
    percent: 0,
    topics: [
      "React Setup",
      "Components",
      "Props & State",
      "Routing",
      "API Integration",
    ],
  },
  {
    title: "Backend Basics",
    percent: 0,
    topics: [
      "Node Basics",
      "Express Server",
      "REST APIs",
      "Auth Intro",
    ],
  },
  {
    title: "Full Stack Project",
    percent: 0,
    topics: [
      "Frontend + Backend Integration",
      "Deployment",
      "Final Project Review",
    ],
  },
];

export default function WebDevelopment() {
  const [activeModule, setActiveModule] = useState(modulesData[2]); // JS default

  return (
    <div className="course-page">

      {/* ===== HERO ===== */}
      <div className="course-hero glass">
        <div className="hero-text">
          <h1>PYTHON + DSA + LEETCODE</h1>
          <p className="hero-sub">
            HTML • CSS • JavaScript • React • Backend
          </p>

          <div className="hero-stats">
            <span>⏱ 5 Months</span>
            <span>🎯 Beginner → Advanced</span>
            <span>🏆 Certificate</span>
            <span>🛠 5+ Projects</span>
          </div>

          <div className="hero-buttons">
            <button className="enroll-btn">Enroll Now</button>
            <button className="outline-btn">Download Syllabus</button>
          </div>
        </div>

        <img src={heroImg} className="hero-img" alt="course" />
      </div>

      {/* ===== MODULES ===== */}
      <h2 className="section-title">Course Curriculum</h2>

      <div className="modules-grid">
        {modulesData.map((mod, i) => (
          <div
            key={i}
            className={`module-card glass ${
              activeModule.title === mod.title ? "active" : ""
            }`}
            onClick={() => setActiveModule(mod)}
          >
            <div className="module-header">
              <span>{mod.title}</span>
              <b>{mod.percent}%</b>
            </div>

            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${mod.percent}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>

      {/* ===== MODULE DETAILS ===== */}
      <div className="module-details glass">
        <h3>{activeModule.title} — Topics</h3>

        <ul className="topic-list">
          {activeModule.topics.map((t, i) => (
            <li key={i}>✔ {t}</li>
          ))}
        </ul>

        {activeModule.project && (
          <div className="project-box">
            🚀 Project: {activeModule.project}
          </div>
        )}
      </div>

      {/* ===== BONUS ===== */}
      <h2 className="section-title">Bonus Benefits</h2>

      <div className="bonus-grid">
        <div className="bonus-card glass">
          <h4>💡 Soft Skills</h4>
          <p>Interview Preparation</p>
          <p>Resume Building</p>
        </div>

        <div className="bonus-card glass">
          <h4>🎯 Career Support</h4>
          <p>Mock Interviews</p>
          <p>Portfolio Review</p>
        </div>
      </div>

    </div>
  );
}
